import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import constitutionModalSteps from '../constants/constitutionModalSteps';
import { useConstitutionModal } from '../context/ConstitutionModalContext';
import ConstitutionModalScriptureView from './ConstitutionModalScriptureView';
import ConstitutionModalMovementsView from './ConstitutionModalMovementsView';
import ConstitutionModalPreview from './ConstitutionModalPreview';

const ConstitutionModalBody: FC = () => {
  const { data } = useConstitutionModal();

  const renderStep = () => {
    if (data.step === constitutionModalSteps.SCRIPTURE) {
      return <ConstitutionModalScriptureView />;
    }

    if (data.step === constitutionModalSteps.PREVIEW) {
      return <ConstitutionModalPreview />;
    }

    return <ConstitutionModalMovementsView />;
  };

  return (
    <Modal.Body>
      <div className="nk-modal">{renderStep()}</div>
    </Modal.Body>
  );
};

export default ConstitutionModalBody;
